/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OrderRequestDto } from '../models/OrderRequestDto';
import type { OrderResponseDto } from '../models/OrderResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class OrderControllerService {

    /**
     * Получение заявки по id
     * @param id
     * @returns OrderResponseDto Заявка успешно получена
     * @throws ApiError
     */
    public static findOrderById(
        id: number,
    ): CancelablePromise<OrderResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/orders/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Заявка не найдена`,
            },
        });
    }

    /**
     * Обновление заявки
     * @param id
     * @param requestBody
     * @returns OrderResponseDto Заявка успешно обновлена
     * @throws ApiError
     */
    public static updateOrder(
        id: number,
        requestBody: OrderRequestDto,
    ): CancelablePromise<OrderResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/orders/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Некорректные данные`,
                404: `Заявка не найдена`,
            },
        });
    }

    /**
     * Удаление заявки
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteOrder(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/orders/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Заявка не найдена`,
            },
        });
    }

    /**
     * Получение списка заявок с фильтрацией
     * @param userId
     * @param engineId
     * @param status
     * @param workType
     * @returns OrderResponseDto Заявки успешно получены
     * @throws ApiError
     */
    public static findOrders(
        userId?: number,
        engineId?: number,
        status?: string,
        workType?: string,
    ): CancelablePromise<Array<OrderResponseDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/orders',
            query: {
                'userId': userId,
                'engineId': engineId,
                'status': status,
                'workType': workType,
            },
        });
    }

    /**
     * Создание заявки
     * @param requestBody
     * @returns OrderResponseDto Заявка успешно создана
     * @throws ApiError
     */
    public static createOrder(
        requestBody: OrderRequestDto,
    ): CancelablePromise<OrderResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/orders',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Некорректные данные`,
            },
        });
    }

}
